// timeTracker.ts
// ———————————————————————————————————————————————————————————————
// Gestión del tracking de tiempo de sesión
// ———————————————————————————————————————————————————————————————

import type { TimeTrackingConfig } from './types';

class TimeTracker {
  private sessionStartTime: number | null = null;
  private config: TimeTrackingConfig = {
    autoTrackTime: false,
    saveTimeOnSave: false,
  };

  /**
   * Configura las opciones de tracking de tiempo
   */
  configure(config: TimeTrackingConfig): void {
    this.config = { ...this.config, ...config };
  }

  /**
   * Obtiene la configuración actual
   */
  getConfig(): TimeTrackingConfig {
    return { ...this.config };
  }

  /**
   * Inicia el tracking de tiempo de sesión
   */
  startSession(): void {
    if (this.config.autoTrackTime) {
      this.sessionStartTime = Date.now();
    }
  }

  /**
   * Detiene el tracking de tiempo de sesión
   */
  stopSession(): void {
    this.sessionStartTime = null;
  }

  /**
   * Obtiene los segundos transcurridos desde el inicio de la sesión
   */
  getElapsedSeconds(): number {
    if (this.sessionStartTime === null) return 0;
    return Math.floor((Date.now() - this.sessionStartTime) / 1000);
  }

  /**
   * Verifica si debe guardar el tiempo en operaciones de guardado
   */
  shouldSaveTimeOnSave(): boolean {
    return this.config.autoTrackTime === true && this.config.saveTimeOnSave === true;
  }

  /**
   * Verifica si el tracking automático está activo
   */
  isAutoTrackingEnabled(): boolean {
    return this.config.autoTrackTime === true;
  }

  /**
   * Verifica si hay una sesión activa
   */
  hasActiveSession(): boolean {
    return this.sessionStartTime !== null;
  }
}

// Singleton para tracking de tiempo
export const timeTracker = new TimeTracker();
